class EditAdminRoles {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');

        this.editManager();
        this.editManagerInput();
    }
    editManager(){
        const thisClass = this;
        /** When user click on edit button redraw modal form and get manager values */
        $(document).on('click', '.edit-manager', function(e) {
            let managerID = $(this).parent()[0].id;
            thisClass.showEditManagerModal(managerID);
        });
    }
    /** Redraw edit manager form by managerID */
    showEditManagerModal(managerID){
        new ModalLoading();
        naja.makeRequest('GET', '/admin-roles/?do=getManagerInfo', {
            'managerID': managerID,
            'organizationID': this.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response){
                new AdminRolesFormValidation('frm-generalForms-editManagerForm-editManagerForm');

                let roleSelect = $('#frm-generalForms-editManagerForm-editManagerForm select[name=roleID]');
                roleSelect.select2({minimumResultsForSearch: -1});
                this.initTagifyInEditManagerForm(response.managerInfo.identityArr, response.managerInfo.allIdentities);
                KTScroll.createInstances();

                let editManagerModal = document.getElementById('edit_manager_modal');
                this.initDeleteManager(editManagerModal, response.managerInfo);

                // Init all popovers
                const popoverTriggerList = [].slice.call(document.querySelectorAll('#edit_team_member_modal [data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });

                new ModalLoading(editManagerModal);
            }
        }).catch(error => {
            new ModalLoading();
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }

    editManagerInput(){
        $(document).on('click', '#frm-generalForms-editManagerForm-editManagerForm .editable-text .edit-section', function(e) {
            let mainDiv = $(this).parent().parent();
            let input = mainDiv.find('.not-edit');
            input.removeClass('not-edit d-none');
            mainDiv.find('.editable-text').remove();
        });
    }


    initTagifyInEditManagerForm(identityArr, allIdentities){
        const identityInput = document.querySelector('#frm-generalForms-editManagerForm-editManagerForm input[name=identities]');

        if(identityInput){
            let tagify = new IdentityTagify(identityInput, allIdentities);

            let names = [];
            for(let i = 0; i < identityArr.length; i++){
                names[i] = identityArr[i]['name'];
            }
            tagify.addTags(names);
        }
    }
    initDeleteManager(editManagerModal, managerInfo){
        const thisClass = this;
        const deleteManagerButton = editManagerModal.querySelector('.delete-manager');
        if(deleteManagerButton){
            let html = `
                <div class="text-center text-primary">You are about to revoke `+(managerInfo.email !== undefined ? `<b>`+managerInfo.email+`</b>` : `this user's`)+` privileges!</div>
                <div class="text-center text-primary mt-5"><b>Please note:</b> Deleting this `+(managerInfo.roleName !== undefined ? managerInfo.roleName : `Admin`)+` will also delete all records (logs) related to their activities.</div>
                <div class="form-check mt-5">
                    <input class="form-check-input float-none corsor-pointer" name="agreeSwalCheckbox" type="checkbox" value="" id="agreeSwalCheckbox" />
                    <label class="form-check-label text-primary corsor-pointer" for="agreeSwalCheckbox">
                        I agree
                    </label>
                </div>`;

            deleteManagerButton.addEventListener('click', function () {
                Swal.fire({
                    html: html,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        let agreeSwalCheckbox = document.querySelector('input[name="agreeSwalCheckbox"]');
                        if(agreeSwalCheckbox && !agreeSwalCheckbox.checked){
                            Swal.showValidationMessage(`You need to agree`);
                            return;
                        }

                        return fetch('/admin-roles?do=removeManager&organizationID='+thisClass.organizationID+'&managerID='+managerInfo.uuid)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        if(result.value === 'deleted') {
                            toastr.success('Admin has been deleted.');
                            bootstrap.Modal.getOrCreateInstance(editManagerModal).hide();
                            new PageDatatableReload();
                        }
                    }
                });
            });
        }
    }
}
window.EditAdminRoles = EditAdminRoles;